import React from 'react';
import GridItem from 'components/Grid/GridItem';
import { translate } from 'components/Translation';
import InfoCard from 'components/Info/InfoCard';
import { EventCodes, PaymentMethods } from 'views/Activities/commons/constants';
import { useSelector } from 'react-redux';
import { getCommonLabels } from '../../../../redux/modules/dynamicLabels/selectors';

interface IAccountInfomrationProps {
	accountType: string | undefined;
	billingType: string | undefined;
	number: string | undefined;
	accountId: number | undefined;
	dst: string | null | undefined;
	eventCode: string | undefined;
	src: string | null | undefined;
}
const AccountInformationCard = ({
	accountType,
	billingType,
	number,
	accountId,
	dst,
	eventCode,
	src,
}: IAccountInfomrationProps) => {
	const commonLabels = useSelector(getCommonLabels);
	const NOT_AVAILABLE = commonLabels.notAvailable;

	const infoElements = [
		{
			title: translate('activities.details.accountType'),
			value: accountType ? accountType : NOT_AVAILABLE,
		},
		{
			title: translate('activities.details.billingType'),
			value: billingType ? billingType : NOT_AVAILABLE,
		},
		{
			title: translate('activities.details.number'),
			value: number ? number : NOT_AVAILABLE,
		},
		{
			title: translate('activities.details.accountId'),
			value: accountId ? accountId.toString() : NOT_AVAILABLE,
		},
	];

	if (
		eventCode === EventCodes.subscriptionCancellation ||
		EventCodes.subscriptionOrder ||
		EventCodes.loyaltyGroupCreation ||
		EventCodes.loyaltyGroupDelete ||
		EventCodes.loyaltyGroupUpdate
	) {
		if (src) {
			infoElements.push({
				title: translate('activities.details.paymentMethod'),
				value: PaymentMethods[src.split('')[0]],
			});
		}
		infoElements.push({
			title: translate('activities.details.numbersAffected'),
			value: dst ? dst : NOT_AVAILABLE,
		});
	}

	return (
		<GridItem xs={12} md={6}>
			<InfoCard elements={infoElements} title={translate('activities.details.accountInformation')} />
		</GridItem>
	);
};

export default AccountInformationCard;
